import { Services as CommunicationServices } from '@smiles/core-communication';

export const getShowMilesFirst = async () => {
  let showMilesFirst = false;

  try {
    const { data }: any = await CommunicationServices.getProdConfigService({
      ProductConfigId: 'hotels-show-miles-first',
    });
    showMilesFirst = Boolean(data?.is_active);
  } catch (error) {
    console.error(error);
  }

  return showMilesFirst;
};
